/**
 * @description: 自定义全局组件
 */
import uploadInTable from './upload-in-table'
import CustomDatePicker from './custom-date-picker'
import ViewLoading from './view-loading'
import ViewMask from './view-mask'
import PageFooter from './page-footer'
import TableFilter from './table-filter'
import filterInput from './table-filter-input'
import HRender from '@/components/H.vue'

const components = {
  install: function (Vue) {
    Vue.component('uploadInTable', uploadInTable);
    Vue.component('CustomDatePicker', CustomDatePicker);
    Vue.component('ViewLoading', ViewLoading);
    Vue.component('ViewMask', ViewMask);
    Vue.component('PageFooter', PageFooter);
    Vue.component('TableFilter', TableFilter);
    Vue.component('filterInput', filterInput);
    Vue.component('HRender', HRender);
  }
}
export default components



// WEBPACK FOOTER //
// ./src/views/my-components/index.js